import styles from "../styles/hero.module.css";


import { Link } from "react-router-dom";


function Hero({ title, subtitle, className }) {
    return (
        <section className={`${styles.hero} ${className}`}>
            <h1 className={styles.titulo}>
                {title ? (
                    <Link to="/" className={`${styles.titleLink} ${className}`}>{title}</Link>

                ) : (
                    <>
                        {/*     <Link className={styles.global} to="/">GLOBAL</Link>
                        <Link className={styles.esport} to="/esport">ESPORT</Link>
                        <span className={styles.i}> I </span>
                        <Link className={styles.salut} to="/salut">SALUT</Link>
  */}                <Link to="/" >
                            <div >
                                    <img className={styles.imagenLetrasHeader} src="assets/img_portada2.png" alt="imagen logotipo"  />
                            </div>
                        </Link>
                    </>


                )}
            </h1>
            {subtitle && <p className={styles.subtitulo}>{subtitle}</p>}
            <span className={styles.tlf}> Telf: 699 12 48 85 </span>
        </section>
    );
}

export default Hero;